(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('DettaglioOrdineSearch', DettaglioOrdineSearch);

    DettaglioOrdineSearch.$inject = ['$resource'];

    function DettaglioOrdineSearch($resource) {
        var resourceUrl =  'api/_search/dettaglio-ordines/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
